export default __webpack_public_path__ + "static/media/cleverModel.fcabbdc7.png";